import { paths } from '@/app/router/paths'
import { firstIncompleteFlowStep, firstIncompleteStep, type FlowResumeState } from './guardRules'
import type { FlowStep, WizardStep } from '../types/session.types'

/** The URL for a given wizard step. */
export function stepPath(appRefNo: string, step: WizardStep): string {
  return paths.apply[step](appRefNo)
}

/** Where a resumed application should land: the earliest step not yet finished. */
export function resumePath(appRefNo: string, completedSteps: WizardStep[]): string {
  return stepPath(appRefNo, firstIncompleteStep(completedSteps))
}

/**
 * The URL for any step of the ten-step flow. Every step past the first needs the
 * minted reference; without one they fall back to the ID-number screen, which is
 * where a reference comes from.
 */
export function flowStepPath(step: FlowStep, appRefNo?: string): string {
  switch (step) {
    case 'idNumber':
      return paths.apply.idNumber
    case 'face':
      return appRefNo ? paths.apply.verify(appRefNo) : paths.apply.idNumber
    case 'submitted':
      return appRefNo ? paths.apply.submitted(appRefNo) : paths.apply.idNumber
    default:
      return appRefNo ? stepPath(appRefNo, step) : paths.apply.idNumber
  }
}

/** Where `/apply` should send a returning citizen. */
export function resumeFlowPath(state: FlowResumeState): string {
  return flowStepPath(firstIncompleteFlowStep(state), state.appRefNo)
}
